import AppService from '@/services/app';
import CashLogService from '@/views/CashLog/CashLogService';

import {
  SET_BRANCHES,
  SET_VALIDATORS,
  SET_FUNDS,
  SET_ASSET_TYPES,
  SET_PAYMENT_REMINDER_CLIENT_ATTITUDES,
  SET_PAYMENT_REMINDER_STATUSES,
  SET_PAYMENT_REMINDER_NEXT_ACTIONS,
  CLEAR,
  SET_CASH_LOG_CATEGORIES,
  SET_SCREEN_SIZE,
  SET_LOCATIONS,
  SET_ASSET_CATEGORIES,
  SET_VALUATORS,
  SET_PRODUCTS,
  SET_STORAGES,
  SET_CONTRACT_DOC_TYPES,
  SET_CLIENT_DOC_TYPES
} from './types';

const actions = {
  async getMisc({ commit }) {
    const { branches, funds, assetTypes } = await AppService.getMisc();

    commit(SET_BRANCHES, { branches });
    commit(SET_FUNDS, { funds });
    commit(SET_ASSET_TYPES, { assetTypes });

    const {
      locations, assetCategories, products, storages, contractDocTypes, clientDocTypes,
      paymentReminderNextActions, paymentReminderClientAttitudes, paymentReminderStatuses
    } = await AppService.getMiscV2();
    commit(SET_LOCATIONS, { locations });
    commit(SET_PRODUCTS, { products });
    commit(SET_ASSET_CATEGORIES, { assetCategories });
    commit(SET_STORAGES, { storages });
    commit(SET_CONTRACT_DOC_TYPES, { contractDocTypes });
    commit(SET_CLIENT_DOC_TYPES, { clientDocTypes });

    commit(SET_PAYMENT_REMINDER_CLIENT_ATTITUDES, { paymentReminderClientAttitudes });
    commit(SET_PAYMENT_REMINDER_STATUSES, { paymentReminderStatuses });
    commit(SET_PAYMENT_REMINDER_NEXT_ACTIONS, { paymentReminderNextActions });
  },

  async getCashLogCategories({ commit }) {
    const categories = await CashLogService.getCashLogCategories();
    commit(SET_CASH_LOG_CATEGORIES, { categories });
  },

  async clearImmediate({ commit }) {
    commit(CLEAR);
  },

  async getValidators({ commit }) {
    const { validators } = await AppService.getValidator();
    commit(SET_VALIDATORS, { validators });
  },

  async getValuators({ commit }) {
    const valuators = await AppService.getValuators();
    commit(SET_VALUATORS, { valuators });
  },

  setScreenSize({ commit }, w) {
    commit(SET_SCREEN_SIZE, w);
  }
};

export default actions;
